import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import router from './router'
import App from './App.vue'

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
  theme: {
    defaultTheme: 'opusTheme',
    themes: {
      opusTheme: {
        dark: false,
        colors: {
          primary: '#004851',       // opus green
          'primary-darken-1': '#003038',
          secondary: '#546E7A',     // blue-grey
          'secondary-darken-1': '#37474F',
          'on-primary': '#FFFFFF',
          'on-secondary': '#FFFFFF',
          'on-success': '#FFFFFF',
          'on-error': '#FFFFFF',
          'on-warning': '#FFFFFF',
          error: '#C62828',
          info: '#0277BD',
          success: '#2E7D32',
          warning: '#F57F17',
          background: '#EDEDEE',
          surface: '#FFFFFF',
        },
      },
    },
  },
  defaults: {
    VCard: { elevation: 1 },
    VBtn: { variant: 'flat' },
    VTextField: { variant: 'outlined', density: 'comfortable' },
    VSelect: { variant: 'outlined', density: 'comfortable' },
    VAutocomplete: { variant: 'outlined', density: 'comfortable' },
    VTextarea: { variant: 'outlined', density: 'comfortable' },
  },
})

createApp(App).use(vuetify).use(router).mount('#app')
